import { useContext } from "react";
import { IsAdminModeContext, IsAdminModeContextProps } from "./context";
import { useIsAdminModeContextController } from "./controller";

const IsAdminModeContextProvider: React.FC<{ children: any }> = ({
  children,
}) => {
  return (
    <IsAdminModeContext.Provider
      value={{ ...useIsAdminModeContextController() }}
    >
      {children}
    </IsAdminModeContext.Provider>
  );
};

function useIsAdminMode(): IsAdminModeContextProps {
  const context = useContext(IsAdminModeContext);

  if (!context) {
    throw new Error(
      "useIsAdminMode must be used within a IsAdminModeContextProvider."
    );
  }

  return context;
}

export { IsAdminModeContextProvider, useIsAdminMode };
